import React, { useState, useEffect, useMemo } from "react";

import Link from "@/utils/link";

import ArticleCard from "@/components/article/ArticleCard";
import Button from "@/ui/Button";

//import { ChevronDoubleRightIcon } from "@heroicons/react/outline";
import { TiChevronRight as ChevronDoubleRightIcon } from "react-icons/ti";

import FaqIcon from "@/components/Logo/FaqIcon";
import DashboardIcon from "@/components/Logo/DashboardIcon";
import RightFitCalculatorIcon from "@/components/Logo/RightFitCalculatorIcon";
import ProfileIcon from "@/components/Logo/ProfileIcon";
import RightFitAssessmentIcon from "@/components/Logo/RightFitAssessment";
import RightFitGuidebooksIcon from "@/components/Logo/RightFitGuidebooksIcon";
import RightFitSearchTimeline from "@/components/Logo/RightFitSearchTimelineIcon";

import HomeHeader from "@/components/home/HomeHeader";
import SeoLinks from "@/components/home/SeoLinks";
import HomeFooter from "@/components/home/HomeFooter";
import NeedHelpBox from "@/components/home/NeedHelpBox";

import { useAuth } from "@/lib/auth";
import SignUpSignIn from "@/components/user/SignUpSignIn";

import { fetchGraphql } from "@/utils/query";

export const ResourceLink = ({ title, href, disabled, openInNewTab }) => {
    if (disabled) {
        return (
            <div className="text-lg">
                <div className="flex items-center space-x-4 text-gray-500 curser-not-allowed">
                    <ChevronDoubleRightIcon className="w-6 h-6 flex-shrink-0 text-gray-500" />
                    <div>{title}</div>
                </div>
            </div>
        );
    }

    if (openInNewTab) {
        return (
            <div className="text-lg">
                <a
                    href={href}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="flex items-center space-x-4 text-black hover:text-primary-500 hover:font-black hover:underline"
                >
                    <ChevronDoubleRightIcon className="w-6 h-6 flex-shrink-0 text-primary-500" />
                    <div>{title}</div>
                </a>
            </div>
        );
    }

    return (
        <div className="text-lg">
            <Link href={href}>
                <a className="flex items-center space-x-4 text-black hover:text-primary-500 hover:font-black hover:underline">
                    <ChevronDoubleRightIcon className="w-6 h-6 flex-shrink-0 text-primary-500" />
                    <div>{title}</div>
                </a>
            </Link>
        </div>
    );
};

const Resources = ({ articles }) => {
    const auth = useAuth();
    const [openSignUp, setOpenSignUp] = useState(false);
    const [openSignIn, setOpenSignIn] = useState(false);

    const userId = auth.user ? auth.user.uid : "";

    return (
        <div className="bg-gray-50">
            <HomeHeader fixed />

            <div className="pt-16 bg-primary-500">
                <div className="container mx-auto px-4 sm:px-16 py-12 mt-12">
                    <h1 className="text-3xl text-primary-50 font-headline font-bold">
                        Resources for Seniors
                    </h1>

                    <p className="mt-4 text-white text-lg">
                        Purple Door Finders provides tools & other resources during your
                        search for senior living and assisted living.
                    </p>
                </div>
            </div>

            <div className="pt-8 pb-8 container mx-auto px-4 sm:px-16">
                <NeedHelpBox />
            </div>

            <div className="pt-8 pb-8 container mx-auto px-4 sm:px-16">
                <div className="grid grid-cols-1 sm:grid-cols-3 gap-x-20">
                    <div className="space-y-6">
                        <h2 className="pb-2 text-2xl text-primary-500 font-bold font-headline border-b border-black">
                            Library
                        </h2>

                        <ResourceLink
                            title="Assisted and Senior Living Guidebooks"
                            href="/resources/guidebooks"
                        />

                        <ResourceLink
                            title="Tour Questionnaire"
                            href="/pdf/PD_Tour_Questionnaire.pdf"
                            openInNewTab={true}
                        />

                        <ResourceLink
                            title="Tour Prep List"
                            href="pdf/PD_Tour_Prep_List.pdf"
                            openInNewTab={true}
                        />

                        <ResourceLink
                            title="Senior Living Articles"
                            href="/resources/articles"
                        />

                        <ResourceLink
                            title="Senior Living Glossary"
                            href="/resources/glossary"
                        />

                        <ResourceLink
                            title="Frequently Asked Questions"
                            href="/resources/faq"
                        />

                        <ResourceLink
                            title="Licensing By State"
                            href="/resources/licensing-by-state"
                        />

                        <ResourceLink
                            title="Medicaid Links By State"
                            href="/resources/medicaid-links-by-state"
                        />

                        <ResourceLink
                            title="Other Resources By State"
                            href="/resources/other-resources-by-state"
                        />

                        <ResourceLink
                            title="Other Web Resources"
                            href="/resources/other-web-resources"
                        />
                    </div>

                    <div className="mt-8 sm:mt-0 space-y-6">
                        <h2 className="pb-2 text-2xl text-primary-500 font-bold font-headline border-b border-black">
                            Tools
                        </h2>

                        {/*userId === "" ? (
                            <div className="">
                                <p>
                                    Account required for access to these interactive tools
                                    and to save to your profile.
                                </p>

                                <div className="mt-1 flex items-center space-x-1">
                                    <button
                                        className="font-black underline text-primary-500 hover:text-primary-400"
                                        onClick={() => {
                                            setOpenSignUp(true);

                                            gtag("event", "conversion", {
                                                send_to:
                                                    "AW-10778046073/z0kvCMDQspMaEPncr5Mo",
                                            });

                                            oaiq(
                                                "measure",
                                                "registration_completed",
                                                { type: "customer_action" }
                                            );
                                        }}
                                    >
                                        Sign up
                                    </button>
                                    <div>for your FREE account.</div>
                                </div>

                                <div className="mt-1">
                                    Already have an account?
                                    <button
                                        className="ml-2 underline text-primary-500 hover:text-primary-400"
                                        onClick={() => setOpenSignIn(true)}
                                    >
                                        Sign in
                                    </button>
                                </div>
                            </div>
                        ) : null*/}

                        <ResourceLink
                            title="Assisted Living Needs Assessment"
                            href="/resources/assessment"
                            disabled={/*userId === ""*/ false}
                        />

                        <ResourceLink
                            title="Assisted Living Preferences Assessment"
                            href="/resources/living-preferences"
                            disabled={/*userId === ""*/ false}
                        />

                        <ResourceLink
                            title="Assisted Living Timeline"
                            href="/resources/timeline"
                            disabled={/*userId === ""*/ false}
                        />

                        <ResourceLink
                            title="Assisted Living Financial Calculator"
                            href="/resources/financial-calculator"
                            disabled={/*userId === ""*/ false}
                        />
                    </div>

                    <div className="mt-8 sm:mt-0">
                        <div className="flex items-center justify-between">
                            <h2 className="text-xl text-primary-500 font-headline font-bold">
                                Recent Articles
                            </h2>

                            <Link href="/resources/articles">
                                <a className="ml-4 text-primary-500 hover:underline">
                                    See All
                                </a>
                            </Link>
                        </div>

                        <div className="mt-8 flex flex-col space-y-8">
                            {articles.map((article) => (
                                <ArticleCard
                                    key={article.articleId}
                                    article={article}
                                    imageHeight="h-40 xl:h-48"
                                />
                            ))}
                        </div>

                        <Button href="/resources/articles" className="mt-4">
                            See All Articles
                        </Button>
                    </div>
                </div>
            </div>

            <div className="z-10">
                <SeoLinks />
                <HomeFooter />
            </div>

            <SignUpSignIn
                openSignUp={openSignUp}
                openSignIn={openSignIn}
                setOpenSignUp={setOpenSignUp}
                setOpenSignIn={setOpenSignIn}
            />
        </div>
    );
};

const ResourceCard = ({ title, description, cta, href, Icon, fill, bg }) => {
    return (
        <div className="relative h-72 border border-gray-800 rounded overflow-hidden">
            <div className={`relative w-full h-32 pt-4 mb-16 ${bg} bg-opacity-75`}>
                <h2 className="px-4 text-2xl text-white text-center font-headline font-bold">
                    {title}
                </h2>
                <div className="absolute top-24 left-1/2 transform -translate-x-1/2">
                    <Icon circleClassName={fill} />
                </div>
            </div>

            <p className="px-4 text-center text-sm">{description}</p>

            <Link href={href}>
                <a className="absolute bottom-2 right-0 left-0 text-center text-primary-500 font-bold hover:underline">
                    {cta}
                </a>
            </Link>
        </div>
    );
};

export const getServerSideProps = async ({ params }) => {
    const result = await fetchGraphql(`
        query {
            articles(limit: 3) {
                articleId
                _createdAt
                _updatedAt
                type
                title
                date
                description
                mainImageUrl
                keywords
                topic
                author_link {
                    name
                }
            }
        }
    `);

    let articles = [];

    // TODO - return only the first few?
    if (result && result.data && result.data.articles) {
        articles = result.data.articles.sort(
            (a, b) => new Date(b._createdAt) - new Date(a._createdAt)
        );
    }

    return {
        props: {
            articles,
        },
    };
};

export default Resources;
